
import { removeOneWidgetWindow, widgetWindowsSelector } from '@/entities/widgetWindows'
import { OLMSApiService } from '@/shared/apis'
import { TREE_WIDGETS } from '@/shared/components/Mosaic/models/widgetType'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { removePlanningShift } from '../slices/planningShiftsSlice'
import { removeRunsheetShift } from '../slices/runsheetShiftsSlice'

export type RemoveShiftPayload = {
  id: EntityId // The Shift Id
}

export const removeShift = createAsyncThunk<void, RemoveShiftPayload, { state: RootState }>(
  'schedule/removeShift',
  async ({ id }, { getState, dispatch }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const activeWidgetWindows = widgetWindowsSelector.selectAll(state).filter(window => window.isActive)
    const endpoint = currentScreen === 'planning' ? '/planning/removeShift' : '/runsheet/removeShift'

    await OLMSApiService.post<null>(endpoint, id)

    if (currentScreen === 'planning') {
      dispatch(removePlanningShift({ id }))

      for (const window of activeWidgetWindows) {
        if (window.widgetType === TREE_WIDGETS.PlanningShiftTable && window.shiftId == id) {
          dispatch(removeOneWidgetWindow(window.id))
        }

        return
      }
    } else if (currentScreen === 'runsheet') {
      dispatch(removeRunsheetShift({ id }))

      for (const window of activeWidgetWindows) {
        if (window.widgetType === TREE_WIDGETS.RunsheetShiftTable && window.shiftId == id) {
          dispatch(removeOneWidgetWindow(window.id))
        }

        return
      }
    }
  },
)
